import { Box } from "@mui/material";
import React, { useEffect } from "react";

import * as authService from "../../service/AuthService";
import * as apiService from "../../service/ApiService";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { ActionType } from "../../constants";
const JobLoader = () => {
  const auth = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const queryParameters = new URLSearchParams(window.location.search);
  const jobToken = queryParameters.get("job_id");
  const appToken = queryParameters.get("app");
  const loggedIn =
    auth.accountData.loginToken !== null &&
    auth.accountData.contactInfo !== null;
  useEffect(() => {
    // get jobs from server
    if (auth.testing) return;
    if (!loggedIn || auth.jobs !== null || auth.error !== null) return;
    apiService.getJobs(dispatch, auth.accountData, jobToken, appToken);
  }, [auth.accountData.loginToken, jobToken, appToken]);
  return (
    <Box
      sx={{
        width: 0,
        height: 0,
        position: "fixed",
      }}
    />
  );
};

export default JobLoader;
